import { z } from 'zod'
import { differenceInCalendarDays, startOfDay } from 'date-fns'

export const MAX_WINDOW_DAYS = 31
export const MAX_MESSAGE = 200

export const filtersFormSchema = z
  .object({
    dateRange: z.object({
      from: z.date({ required_error: 'Start date is required' }),
      to: z.date({ required_error: 'End date is required' }),
    }),
    companyId: z.number().int().positive().nullish(),
    userId: z.number().int().positive().nullish(),
    subjectUserId: z.number().int().positive().nullish(),
    shiftId: z.number().int().positive().nullish(),
    eventType: z.string().default(''),
    messageContains: z.string().max(MAX_MESSAGE).default(''),
    limit: z.preprocess(
      (v) => (v === null || v === undefined ? 50 : v),
      z.number().int().min(1).max(100)
    ),
  })
  .superRefine((data, ctx) => {
    const from = startOfDay(data.dateRange.from)
    const to = startOfDay(data.dateRange.to)
    if (to < from) {
      ctx.addIssue({
        code: 'custom',
        message: 'End date must be on or after start date.',
        path: ['dateRange', 'to'],
      })
      return
    }

    const calendarSpan = differenceInCalendarDays(to, from) + 1
    if (calendarSpan > MAX_WINDOW_DAYS) {
      ctx.addIssue({
        code: 'custom',
        message: `Time window must be at most ${MAX_WINDOW_DAYS} calendar days.`,
        path: ['dateRange'],
      })
    }

    const msg = data.messageContains.trim()
    const hasIdNarrowing =
      data.companyId != null ||
      data.userId != null ||
      data.subjectUserId != null ||
      data.shiftId != null
    const narrowed =
      hasIdNarrowing || data.eventType.trim().length > 0 || msg.length > 0

    if (!narrowed) {
      ctx.addIssue({
        code: 'custom',
        message:
          'Provide at least one of company ID, user ID, subject user ID, shift ID, event type(s), or message text.',
        path: ['eventType'],
      })
    }
  })

export type FiltersFormValues = z.infer<typeof filtersFormSchema>
